export const getAnnouncementsPath = (spaceId: string) =>
  `/dashboard/${spaceId}/community/announcements`;

export const getCommonRoomPath = (spaceId: string) =>
  `/dashboard/${spaceId}/community/common-room`;

export const getAssignmentsPath = (spaceId: string) =>
  `/dashboard/${spaceId}/journey/assignments`;
